<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';

export default {
  components: {
    Modal,
  },

  mixins: [modalMixin],

  emits: ['close', 'reset'],

  computed: {
    modalOptions() {
      return {
        onHidden: () => this.$emit('close'),
      };
    },
  },

  methods: {
    reset() {
      Toolkit.helpers.buttons.addLoadingState(this.$refs.resetButtonRef);
      this.$emit('reset');
    },
  },
};
</script>

<template>
  <modal
    :id="id"
    :title="$t('EngravingTool.inactivity.title')"
    :is-closable="false"
    :options="modalOptions"
    default
    header-bordered
    style="z-index: 99999"
  >
    <template #content>
      <p>{{ $t('EngravingTool.inactivity.text') }}</p>
    </template>

    <template #footer>
      <button type="button" class="btn btn--default btn--negative" @click="close()">
        <span class="btn__text">{{ $t('EngravingTool.inactivity.continue') }}</span>
      </button>

      <button ref="resetButtonRef" type="button" class="btn btn--default" @click="reset()">
        <span class="btn__text">{{ $t('EngravingTool.inactivity.reset') }}</span>
      </button>
    </template>
  </modal>
</template>
